const ROLE_SUPER_USER = 110
const ROLE_LOGISTIC_MANAGER = 116
const ROLE_LOGISTIC_CONTRIBUTOR = 117

function normalizeRoleIds(roles) {
	if (!Array.isArray(roles)) {
		return []
	}
	return roles
		.map((role) => {
			if (role && typeof role === "object") {
				return Number(role.id ?? role.ID)
			}
			return Number(role)
		})
		.filter((id) => !Number.isNaN(id))
}

export function isLogisticContributorOnly(roleIds) {
	const ids = normalizeRoleIds(roleIds)
	return ids.includes(ROLE_LOGISTIC_CONTRIBUTOR)
		&& !ids.includes(ROLE_LOGISTIC_MANAGER)
}

export function canEnterKpiFromRoles(roleIds) {
	const ids = normalizeRoleIds(roleIds)
	if (isLogisticContributorOnly(ids)) {
		return false
	}
	if (ids.includes(ROLE_LOGISTIC_MANAGER) || ids.includes(ROLE_SUPER_USER)) {
		return true
	}
	return null
}

export function canUploadContractFromRoles(roleIds) {
	const ids = normalizeRoleIds(roleIds)
	return ids.includes(ROLE_LOGISTIC_MANAGER)
		|| ids.includes(ROLE_LOGISTIC_CONTRIBUTOR)
}
